import {
  chakra,
  forwardRef,
  HTMLChakraProps,
  ThemeTypings,
  useMultiStyleConfig,
} from '@chakra-ui/react';

export interface ProgressBarProps extends HTMLChakraProps<'div'> {
  ratio: number;
  size?: ThemeTypings['components']['ProgressBar']['sizes'];
  // use this only if really necessary 🙏
  barProps?: HTMLChakraProps<'div'>;
}

const ProgressBar = forwardRef<ProgressBarProps, 'div'>(
  ({ barProps, ratio, size, ...props }, ref) => {
    const styles = useMultiStyleConfig('ProgressBar', {
      size,
    });

    return (
      <chakra.div __css={styles.container} ref={ref} {...props}>
        <chakra.div __css={styles.bar} {...barProps} flex={ratio} />
      </chakra.div>
    );
  },
);

export default ProgressBar;
